module.exports = __webpack_public_path__ + "img/bg_14.53c2b608.png";